function SocialIcon({ href, icon, label, className = '' }) {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer"
      className={`text-primary hover:opacity-70 transition-opacity flex items-center justify-center ml-5 ${className}`}
      aria-label={label}
    >
      {icon}
    </a>
  );
}

export default SocialIcon;

